import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

/*
  Generated class for the DataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DataProvider {

  countries:any = null;

  API_URL = 'assets/';


  constructor(
    private http: HttpClient
  ) {
    // console.log('Hello DataProvider Provider');
  }


  getCountries(){
    // console.log('getMatchs');
    return new Promise((resolve, reject) => {
    // console.log("getMatchs",this.matchs);
      if(this.countries != null){
        resolve(this.countries);
        return;
      }

      // console.log('getMatchs http');
      this.get('data/countries.json')
      .then((data) => {
        // console.log("getMatchs", data);
        this.countries = data;
        resolve(this.countries);
      })
      .catch((error) => {
        console.error(error);
      })
    });
  }


  get(url, params = null, headers = null) {
    return new Promise((resolve, reject) => {
        this.http.get(this.API_URL + url)
          .subscribe(data => {
            resolve(data);
          }, err => {
            reject(err);
          });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/data/data.ts